import HeaderWithIcons from '@components/app/HeaderWithIcons';
// import ImamrezaCompetition from '@components/competitions/levels/imamreza';
// import ChannelHeader from '@components/network/ChannelHeader';
import {ICompetition} from '@components/competitions/ICompetitions';
// import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {appConfig} from '@config';
import {CompetitionTekyehmajaziContext} from '@context/CompetitionTekyehmajaziContext';
import {Box} from '@mui/material';
import socketCompetition from '@sockets/competition';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import Mission0 from './Mission0';
// import Mission1 from './Mission1';
const now: Date = new Date();
const currentDate: number = now.getDate();
export default function Tekyehmajazi() {
	let referrer = '', socialGroup = '';
	const {t} = useTranslation();
	const location = useLocation();
	if (location.state) {
		referrer = location.state?.referrer ?? '';
		if (referrer == 'shad') {
			socialGroup = 'shad';
		}
	}
	const [competition, setCompetition] = useState<ICompetition>({});
	const [mission, setMission] = useState<number>(0);
	const [phone, setPhone] = useState<string>('');
	const [answers, setAnswers] = useState<{}>({});
	const [correctAnswers, setCorrectAnswers] = useState<number[]>([]);
	const [day, setDay] = useState<number>(currentDate);
	
	let competitionObject = useLoaderData() as ICompetition;
	useEffect(() => {
		socketCompetition.connect();
	}, []);
	useEffect(() => {
		setCompetition(competitionObject);
	}, []);
	
	return (
		<>
			<CompetitionTekyehmajaziContext.Provider value={{
				competition,
				mission,
				setMission,
				phone,
				setPhone,
				day,
				setDay,
				answers,
				setAnswers,
				correctAnswers,
				setCorrectAnswers
			}}>
				<Box className="w-full flex justify-center flex-col">
					{/*<CompetitionWordsHeader/>*/}
					<HeaderWithIcons title={competition.name ?? 'مسابقه بزرگ "تکیه مجازی"!'} home={true}
					                 backUrl={'/competition/3'}/>
					<Box
						// className="flex flex-col w-full h-[calc(100vh-70px)] bg-no-repeat bg-cover overflow-hidden justify-center align-middle"
						className="tekyehmajazi-bg flex flex-col w-full h-[calc(100vh-55px)] bg-repeat overflow-y-scroll justify-center"
						// sx={{
						// 	backgroundImage: `url(${bg})`,
						// 	backgroundRepeat: 'no-repeat',
						// 	backgroundSize: 'cover',
						// 	scale: 0.5,
						// }}
					>
						<Mission0/>
					</Box>
				</Box>
			</CompetitionTekyehmajaziContext.Provider>
		</>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function wordsLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}move/${data.params.competitionId}`,
		method: 'GET'
	});
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
